import styled from 'styled-components';

import media from '../../styles/media.style';
import { PAGE_WIDTH } from '../../styles/variables.style';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 5px 0 50px;

  ${media.tabletL`
    padding-bottom: 150px;
  `};
`;

export const Title = styled.div`
  font-family: FuturaStd;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.7px;
  padding-bottom: 25px;
  position: relative;
  text-transform: uppercase;

  &::after {
    background-color: #333;
    bottom: 0;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

export const FlexboxWrapper = styled.div`
  overflow-x: scroll;
  padding-bottom: 15px;
  width: 100%;
  -webkit-overflow-scrolling: touch;

  ${media.tabletL`
    overflow-x: hidden;
  `};
`;

export const Flexbox = styled.div`
  display: flex;
  padding: 20px 20px 0;
  width: max-content;

  ${media.tabletL`
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin: auto;
    max-width: 100%;
    padding: 45px 190px 0;
    width: ${PAGE_WIDTH}px;
  `};
`;

export const Step = styled.div`
  margin-left: 20px;
  width: calc(100vw - 80px);
  padding-bottom: 70px;

  ${media.tabletL`
    margin-left: 0;
    width: calc((100% - 40px) / 3);
    margin-left: 20px;
    &:nth-child(3n-2) {
      margin-left: 0;
    }
  `};

  &:first-child {
    margin-left: 0;
  }
`;

export const StepName = styled.div``;

export const StepImage = styled.div`
  margin-top: 15px;
  width: 100%;
`;

export const StepTitle = styled.div`
  margin-top: 20px;
`;

export const StepDescription = styled.div`
  margin-top: 12px;
  margin-bottom: 25px;
`;

export const StepProduct = styled.div`
  margin-bottom: 10px;
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/TreatmentProcess.style.js